import type {Property} from "@/src/modules/properties/types";
import {getShiftPrimaryProperty} from "@/src/modules/shifts/lib/get-shift-primary-property";
import type {Shift} from "@/src/modules/shifts/types";

import {userPropertyService} from "../services/user-property";
import {useUserPropertyStore} from "../store/user-property";

let pendingPrimarySyncShiftId: number | null = null;

export function markPendingActiveShiftPrimaryPropertySync(shiftId: number) {
  pendingPrimarySyncShiftId = shiftId;
}

export function consumePendingActiveShiftPrimaryPropertySync(shiftId: number): boolean {
  if (pendingPrimarySyncShiftId !== shiftId) {
    return false;
  }
  pendingPrimarySyncShiftId = null;
  return true;
}

/** Switch global property context to the shift's primary assignment when possible. */
export function applyActiveShiftPrimaryProperty(
  shift: Shift,
  meProperties: readonly Property[],
): boolean {
  const primary = getShiftPrimaryProperty(shift);
  if (!primary?.property?.id) {
    return false;
  }

  const match = meProperties.find((p) => String(p.id) === String(primary.property.id));
  if (!match) {
    return false;
  }

  const current = useUserPropertyStore.getState().userProperty;
  if (String(current?.id) === String(match.id)) {
    return true;
  }

  userPropertyService.setUserProperty(match);
  return true;
}
